module.exports = __webpack_public_path__ + "assets/img/5ece86a0bc5d1eac52e898a75d9099cd.svg";